module.exports = __webpack_public_path__ + "static/img/tag-peixun@2x.e01085f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tag-peixun@2x.png
// module id = 380
// module chunks = 0